import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerPayment extends AManagerApi {
    protected _url: string = '/owner/payment';
}
